import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import timeEntryReducer from '../slices/timeEntrySlice';
import workReducer from '../slices/workScheduleSlice';
import overviewReducer from '../slices/overviewSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    time: timeEntryReducer,
    work: workReducer, // Achtung: workScheduleSlice heißt im Store "work"
    overview: overviewReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
